/**
 * 模型状态钩子
 * 提供React组件使用的模型状态管理接口
 */
import { useState, useEffect } from 'react';
import ModelStateManager from '../services/ModelStateManager.js';
/**
 * 使用模型状态钩子
 * @returns 模型状态和设置函数
 */
export function useModelState() {
    const manager = ModelStateManager.getInstance();
    const [model, setModelState] = useState(manager.getModel());
    useEffect(() => {
        // 订阅模型变化
        const unsubscribe = manager.subscribe(newModel => {
            setModelState(newModel);
        });
        // 组件卸载时取消订阅
        return unsubscribe;
    }, [manager]);
    /**
     * 设置模型函数
     * 更新本地状态并通知其他组件
     */
    const setModel = (modelId) => {
        manager.setModel(modelId);
    };
    return { model, setModel };
}
//# sourceMappingURL=useModelState.js.map